import React from 'react';
import { useTranslation } from 'react-i18next';
import Truncate from 'react-truncate';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  DEFAULT_LANGUAGE,
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
} from '../../config/constants';
import {
  CoreLink,
} from '..';


import './style.scss';

const Teaser = ({ entity, showDate, showBody }) => {
  const { t } = useTranslation();

  const created = new Date(entity.getIn(['created', 0, 'value']));

  return (
    <div className="Teaser">
      <div className="Teaser__image">
        <Image
          alt={entity.getIn(['title', 0, 'value'])}
          src={{
            [SCREEN_MOBILE]: entity.getIn(['field_image', 0, 'styles', 'ratio_16_9_sm']),
            [SCREEN_TABLET]: entity.getIn(['field_image', 0, 'styles', 'ratio_1_1_sm']),
            [SCREEN_NORMAL]: entity.getIn(['field_image', 0, 'styles', 'ratio_4_3_md']),
          }}
          includeWebP
        />
        {showDate &&
          <div className="Teaser__date">
            <div className="Teaser__date__day">{created.getDate()}</div>
            <div className="Teaser__date__month">{created.toLocaleString('nl-NL', { month: 'short' })}</div>
          </div>}
      </div>
      <h3 className="Teaser__title">
        <div>
          <Truncate lines={2} ellipsis="..." trimWhitespace>
            {entity.getIn(['title', 0, 'value'])}
          </Truncate>
        </div>
      </h3>
      {showBody &&
        <div className="Teaser__body">
          <Truncate lines={3} ellipsis="..." trimWhitespace>
            <WysiwygField
              property="schema:text"
              html={entity.getIn(['body', 0, 'summary'], entity.getIn(['body', 0, 'processed']))}
            />
          </Truncate>
        </div>}
      <p className="Teaser__more">{t('read_more')}</p>
      <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="Teaser__link overlapping-link" />
    </div>
  );
};

export default Teaser;
